<script setup lang="ts">
import { getPrefecturesByAreaCd } from '@/javascripts/utils/inquiry_form_options';
import Inquiry from '@/javascripts/utils/inquiry';
import SlideIndicator from './slide_indicator.vue';

const emit = defineEmits(['next', 'back']);

const props = defineProps<{
  inquiry: Inquiry,
  currentSlideIndex: number,
}>();

const prefectures = getPrefecturesByAreaCd(props.inquiry.areaCd);

const emitNextIfUnchanged = function(clicked: number | string) {
  if (props.inquiry.prefectureCd == clicked) {
    emit('next');
  }
}
</script>

<template>
  <div class="inner_content inner_step">
    <div class="main_content step_content">
      <SlideIndicator :current-slide-index="currentSlideIndex" />
      <h2>あなたのお住まいの都道府県は？</h2>
      <div class="box_step_btn">
        <div  
          v-for="prefecture in prefectures"
          :key="prefecture.cd"
          class="step_btn"
        >
          <label :for="`prefecture_${prefecture.cd}`">
            <input
              :id="`prefecture_${prefecture.cd}`"
              v-model="inquiry.prefectureCd"
              type="radio"
              name="prefecture_cd"
              :value="prefecture.cd"
              @change="emit('next')"
              @click="emitNextIfUnchanged(prefecture.cd)"
            >
            <p>{{ prefecture.text }}</p>
          </label>
        </div>
      </div>
      <div class="box_btn_nextback">
        <div class="btn_back">
          <button @click.once="emit('back')">
            <span>戻る</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
